const normalizeOption = option => {
  if (typeof option === 'string' || typeof option === 'number') {
    const id = String(option).trim();
    return id ? { id, label: id } : null;
  }
  if (!option || typeof option !== 'object') return null;

  const rawId = option.id ?? option.scenario_id ?? option.value ?? option.SCENID;
  const id = rawId == null ? '' : String(rawId).trim();
  if (!id) return null;

  const rawLabel = option.label ?? option.scenario_name ?? option.name ?? option.SCENARIO;
  const label = rawLabel == null ? '' : String(rawLabel).trim();
  return { id, label: label || id };
};

export const normalizeCurveScenarioOptions = catalog => {
  const rawOptions = [
    ...(Array.isArray(catalog?.scenario_options) ? catalog.scenario_options : []),
    ...(Array.isArray(catalog?.scenarios) ? catalog.scenarios : []),
  ];
  const uniqueOptions = new Map();
  rawOptions.forEach(rawOption => {
    const option = normalizeOption(rawOption);
    if (option && !uniqueOptions.has(option.id)) uniqueOptions.set(option.id, option);
  });
  return [...uniqueOptions.values()];
};

export const normalizeCurveScenarioCatalog = catalog => {
  const scenarioOptions = normalizeCurveScenarioOptions(catalog);
  return {
    ...(catalog || {}),
    scenarios: scenarioOptions.map(option => option.id),
    scenario_options: scenarioOptions,
  };
};

export const getCurveScenarioLabel = (scenarioId, scenarioOptions = []) => {
  if (!scenarioId) return 'Base curve';
  const normalizedId = String(scenarioId);
  return normalizeCurveScenarioOptions({ scenario_options: scenarioOptions })
    .find(option => option.id === normalizedId)?.label || normalizedId;
};
